import store from '@/store'

/**
 * Lista los permisos del usuario respecto a los seteados en la view
 * @param {Object} formPermissions - Permisos seteados en el formulario
 * @returns {Object} - which permissions has current user
 */
export const checkUserPermissions = (formPermissions) => {
  const userPrivileges = getCurrentUserPrivileges()
  const userPermissions = {
    allowAccess: false,
    allowCreate: false,
    allowUpdate: false
  }
  for (const permission of formPermissions.allowAccess) {
    userPermissions.allowAccess = userPrivileges.some(privilege => privilege.codigo_privilegio === permission)
    if (userPermissions.allowAccess) break
  }
  for (const permission of formPermissions.allowCreate) {
    userPermissions.allowCreate = userPrivileges.some(privilege => privilege.codigo_privilegio === permission)
    if (userPermissions.allowCreate) break
  }
  for (const permission of formPermissions.allowUpdate) {
    userPermissions.allowUpdate = userPrivileges.some(privilege => privilege.codigo_privilegio === permission)
    if (userPermissions.allowUpdate) break
  }
  // Por defecto permito el acceso
  if (!formPermissions.allowAccess.length) {
    userPermissions.allowAccess = true
  }
  if (!formPermissions.allowCreate.length) {
    userPermissions.allowCreate = true
  }
  if (!formPermissions.allowUpdate.length) {
    userPermissions.allowUpdate = true
  }
  return userPermissions
}
/**
 * Verifica los permisos de usuario para cada campo del formbuilder
 * @param {Array} elementPermissions - Lista de codigo_privilegio del campo
 * @returns {Boolean} - Si el usuario tiene permisos o no
 */
export const checkFormElementPermissionToEdit = (elementPermissions) => {
  const userPrivileges = getCurrentUserPrivileges()
  let userHasPermission = false
  for (const permission of elementPermissions) {
    userHasPermission = userPrivileges.some(privilege => privilege.codigo_privilegio === permission)
    if (userHasPermission) break
  }
  return userHasPermission
}
/**
 * Obtenemos los permisos del usuario actual
 * @returns {Array} - Los permisos del usuario logueado
 */
export const getCurrentUserPrivileges = () => {
  return store.getters['session/userPrivileges']
}
